import { render, staticRenderFns } from "./VideoQuestion.vue?vue&type=template&id=59cbb2a8&scoped=true"
import script from "./VideoQuestion.vue?vue&type=script&lang=js"
export * from "./VideoQuestion.vue?vue&type=script&lang=js"
import style0 from "./VideoQuestion.vue?vue&type=style&index=0&id=59cbb2a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cbb2a8",
  null
  
)

export default component.exports